import type { ComposerTranslation } from 'vue-i18n'

import type { Location } from './location'
import type { UserAccountUpdateParams } from './userAccount'
import type { UserEmailSettingUpdateParams } from './userEmailSetting'

import type { Tables, TablesUpdate } from '~/apis/generated/database'
import type { getUsers } from '~/repositories/userRepository'

export type User = Omit<Tables<'users'>, 'location_id'>

type UserUpdateParams = Omit<TablesUpdate<'users'>, 'location_id'> & { locationIds?: Location['id'][] }
export type UserProfileUpdateParams = UserUpdateParams & UserAccountUpdateParams & UserEmailSettingUpdateParams

export type UserProfile = User & {
  accountId: Tables<'user_accounts'>['id']
  email: Tables<'user_accounts'>['email']
  isPending: Tables<'user_accounts'>['is_pending']
  user_email_settings: Tables<'user_email_settings'> | null
  locations: Pick<Tables<'locations'>, 'id' | 'name' | 'position'>[]
}

export const MAX_USER_LOCATIONS_COUNT = 50

export const userRoles = ['ORGANIZATION_ADMIN', 'LOCATION_ADMIN', 'WORK_ADMIN'] satisfies User['role'][]
export function isUserRole(value: string | null): value is User['role'] {
  return userRoles.some((userRole) => userRole === value)
}

// 拠点の管理者候補。useFetchLocationAdmins が返す1件分
export type AdminCandidate = Awaited<ReturnType<typeof getUsers>>[number]

export const convertUserProfile = (user: Awaited<ReturnType<typeof getUsers>>[number]): UserProfile => {
  return {
    ...user,
    accountId: user.user_account.id,
    email: user.user_account.email,
    isPending: user.user_account.is_pending,
  }
}

export const convertUserRoleName = (role: User['role'], t: ComposerTranslation) => {
  switch (role) {
    case 'ORGANIZATION_ADMIN':
      return t('組織管理者')
    case 'LOCATION_ADMIN':
      return t('拠点管理者')
    case 'WORK_ADMIN':
      return t('作業管理者')
    default:
      return '-'
  }
}
